import React from "react";
import { ReactComponent as DashedCircleIcon } from "../../../assets/dashed-border-circle.svg";
import { ReactComponent as BlueTickIcon } from "../../../assets/blue-tick.svg";
import { ReactComponent as TelegramIcon } from "../../../assets/telegram.svg";
import { ReactComponent as TwitterIcon } from "../../../assets/twitter.svg";
import { ReactComponent as WhatsappIcon } from "../../../assets/whatsapp.svg";
import { ReactComponent as AlternateIcon } from "../../../assets/alternate_email.svg";
import { ReactComponent as CopyIcon } from "../../../assets/copy-icon.svg";
import Button from "../../../component/common/Button";

const EventPublished = () => {
  
  return (
    <div className="mt-[16px] mb-0 sm:mb-[16px] p-[10px] xs:p-4 bg-white rounded-[10px] min-h-[600px] flex items-center justify-center">
      <div className="flex flex-col items-center w-full">
        <div className="w-[120px] relative h-[120px] flex items-center bg-[#F5F6FA] justify-center rounded-full">
          <DashedCircleIcon className="absolute left-2 top-2 flex items-center justify-center" />
          <span className="w-[120px] h-[120px] rounded-full absolute left-2 top-2 flex items-center justify-center">
            <BlueTickIcon />
          </span>
        </div>

        <h1 className="heading text-[25px] xs:text-[30px] mt-[25px] mb-2  text-dark-blue">
          Event Published!
        </h1>
        <p className="text-[#626570] xs:text-base text-sm text-center w-full">
          An email with event url is sent to the respective emails.
        </p>

        <div className="px-1 w-full xs:max-w-[375px] min-h-[265px] bg-[#F5F6FA] rounded-[10px] mt-[35px] flex flex-col items-center pt-[28px] ">
          <div className="flex items-center gap-3">
            <div className="text-center">
              <div className="flex items-center justify-center w-10 h-10 rounded-full bg-white">
                <TelegramIcon />
              </div>
              <h6 className="text-[#3D5A80] text-center text-[10px] mt-1">
                Telegram
              </h6>
            </div>
            <div className="text-center">
              <div className="flex items-center justify-center w-10 h-10 rounded-full bg-white">
                <TwitterIcon />
              </div>
              <h6 className="text-[#3D5A80] text-center text-[10px] mt-1">
                Twitter
              </h6>
            </div>
            <div className="text-center">
              <div className="flex items-center justify-center w-10 h-10 rounded-full bg-white">
                <WhatsappIcon />
              </div>
              <h6 className="text-[#3D5A80] text-center text-[10px] mt-1">
                Whatsapp
              </h6>
            </div>
            <div className="text-center">
              <div className="flex items-center justify-center w-10 h-10 rounded-full bg-[#E5EBFF]">
                <AlternateIcon />
              </div>
              <h6 className="text-dark-blue text-center text-[10px] mt-1">
                E-mail
              </h6>
            </div>
          </div>

          <div className="mt-[41px] w-full flex flex-col items-center">
            <h6 className="text-dark-blue text-center text-[10px] mt-1">
              Or share with link
            </h6>

            <div className="bg-white w-full xs:w-[321px] rounded-[10px] mt-2 py-[13px] px-[11px] flex items-center justify-between">
              <h6 className="text-dark-blue text-center text-[12px]  truncate w-[90%]">
                https://www.figma.com/file/NlfVhYygR9mAQasassdsada/Sharejahnbakfnliajbnkc
                a
              </h6>
              <CopyIcon />
            </div>
          </div>

          <div className="flex justify-center mt-[32px] mb-[23px]">
            <Button
              content="View Event"
              classes="py-[10px] px-[40px] m-0 xs:px-[61px] text-sm bg-gradient-to-t from-dark-blue to-[#FFFFFF1F]"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventPublished;
